import React, { useEffect, useState, useRef } from "react";
import Image from "../assets/Topclan.png";
import navni from "../assets/navni.png";
import anamika from "../assets/anamika.png";
import asis from "../assets/asis.png";
import narsingh from "../assets/narsingh.png";
import jajnya from "../assets/jajnya.png";
import vivek from "../assets/vivek.png";
import areena from "../assets/areena.png";

const teamMembers = [
  { name: "Navni Naurahee", designation: "Senior manager", image: navni },
  { name: "Anamika", designation: "HR manager", image: anamika },
  { name: "Asis kaur(Team Lead)", designation: "Software Engineer", image: asis },
  { name: "Narsingh", designation: "Software Engineer", image: narsingh },
  { name: "Jajnyaseni Swain", designation: "Software Engineer", image: jajnya },
  { name: "Vivek kumar", designation: "Software Engineer", image: vivek },
  { name: "Areena Beri", designation: "Software Engineer", image: areena },
];

export default function About() {
  const [isVisible, setIsVisible] = useState(false);
  const aboutRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (aboutRef.current) {
      observer.observe(aboutRef.current);
    }

    return () => {
      if (aboutRef.current) {
        observer.unobserve(aboutRef.current);
      }
    };
  }, []);

  return (
    <div id="about" ref={aboutRef} className="py-10 bg-gray-200">
      <style>
        {`
          @keyframes fadeInUp {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }

          .fadeInUp { animation: fadeInUp 1s ease-out; }
        `}
      </style>
      <div className="max-w-6xl mx-auto px-4">
        <div className={`flex flex-col md:flex-row items-center ${isVisible ? "fadeInUp" : ""}`}>
          <div className="md:w-1/2 mb-8 md:mb-0">
            <h2 className={`text-3xl font-bold mb-4 ${isVisible ? "fadeInUp" : ""}`}>About Us</h2>
            <p className={`mb-4 ${isVisible ? "fadeInUp" : ""}`}>
              The Outsource Pro (TOP) was launched after its founders recognized a need for more comprehensive and secure outsourcing solutions.
            </p>
            <p className={`mb-4 ${isVisible ? "fadeInUp" : ""}`}>
              Redefining outsourcing is at the heart of our business, and our innovative Managed Outsourcing Services ensure lasting client partnerships.
            </p>
            <p className={`mb-4 ${isVisible ? "fadeInUp" : ""}`}>
              With secure offices across India and Australia, we ensure the highest levels of physical and data security for our clients.
            </p>
          </div>
          <div className={`md:w-1/2 md:ml-10 md:pl-8 ${isVisible ? "fadeInUp" : ""}`}>
            <img src={Image} alt="About Us" className="w-50 h-auto md:w-100 rounded-lg" />
          </div>
        </div>

        {/* Our Team Section */}
        <div className="mt-16 text-center">
          <h2 className="text-3xl font-bold mb-8">Our Team</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
            {teamMembers.map((member, index) => (
              <div key={index} className="bg-white p-1 rounded-lg shadow-lg text-center">
                <img src={member.image} alt={member.name} className="w-full h-100 object-cover rounded-lg" />
                <h3 className="text-lg font-semibold mt-4">{member.name}</h3>
                <p className="text-sm text-gray-600">{member.designation}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
